__webpack_require__.O(0, ["main"], () => {
	__webpack_require__.E("components");
}, 5);